<div class="slider-side-counter" [ngClass]="{'-inverted': inverted}">
    <div class="slider-side-counter__inner">
        <shared-loader-for-spinner class="slider-side-counter__loader" *ngIf="isLoading"></shared-loader-for-spinner>

        <div class="slider-side-counter__content" [ngClass]="{'is-loading': isLoading}" #contentElem>
            <ng-template #tpl>
                <ng-content></ng-content>
            </ng-template>

            <shared-slider-list #listElem class="slider-side-counter__list" [slides]="tpl"
                (onContentChange)="handleContentChange($event)"
                [ngStyle]="{'width': listTotalWidth + 'px', 'transform': 'translate('+listOffset+'px,0)', 'transition-duration': isAnimating ? transitionDuration +'ms' : 0, 'transition-type': 'linear'}">
            </shared-slider-list>
        </div>

        <div class="slider-side-counter__nav" *ngIf="showArrows">
            <shared-icon-btn [inverted]="inverted" class="slider-side-counter__arrow -for-prev" [size]="'xs'"
                [disabled]="!canGoBack" [icon]="iconPrev" (onClick)="handlePrevClick($event)">
            </shared-icon-btn>

            <div class="slider-side-counter__info">
                {{currentCount}} of {{totalCount}}
            </div>

            <shared-icon-btn [inverted]="inverted" class="slider-side-counter__arrow -for-next" [size]="'xs'"
                [disabled]="!canGoNext" [icon]="iconNext" (onClick)="handleNextClick($event)">
            </shared-icon-btn>
        </div>
    </div>

    <shared-slider-dots class="slider-side-counter__dots" *ngIf="showDots" [disabled]="!canUseDots"
        [currentActive]="activeIndex" [total]="maxIndex + 1" (onDotClick)="handleDotClick($event)">
    </shared-slider-dots>

</div>